import type { CSSProperties } from 'react'

export const styles: Record<string, CSSProperties> = {
	overlay: {
		position: 'fixed',
		zIndex: 99999,
		fontFamily: 'monospace',
		fontSize: '12px',
		lineHeight: 1.4
	},
	panel: {
		backgroundColor: '#1e1e1e',
		border: '1px solid #333',
		borderRadius: '8px',
		boxShadow: '0 4px 20px rgba(0, 0, 0, 0.5)',
		display: 'flex',
		flexDirection: 'column',
		overflow: 'hidden',
		width: '100%',
		height: '100%',
		maxWidth: '90vw'
	},
	header: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		padding: '8px 12px',
		backgroundColor: '#2d2d2d',
		borderBottom: '1px solid #333',
		cursor: 'move',
		userSelect: 'none'
	},
	headerTitle: {
		color: '#fff',
		fontWeight: 'bold',
		fontSize: '13px'
	},
	headerButtons: {
		display: 'flex',
		gap: '8px'
	},
	iconButton: {
		background: 'none',
		border: 'none',
		color: '#888',
		cursor: 'pointer',
		padding: '4px',
		borderRadius: '4px',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center'
	},
	tabs: {
		display: 'flex',
		borderBottom: '1px solid #333',
		backgroundColor: '#252525'
	},
	tab: {
		padding: '8px 16px',
		background: 'none',
		borderTop: 'none',
		borderLeft: 'none',
		borderRight: 'none',
		borderBottom: '2px solid transparent',
		color: '#888',
		cursor: 'pointer',
		transition: 'all 0.2s'
	},
	tabActive: {
		color: '#fff',
		borderBottom: '2px solid #007acc'
	},
	content: {
		flex: 1,
		overflow: 'auto',
		padding: '8px'
	},
	logEntry: {
		padding: '6px 8px',
		borderRadius: '4px',
		marginBottom: '4px',
		wordBreak: 'break-word'
	},
	logLog: {
		backgroundColor: 'rgba(255, 255, 255, 0.05)',
		color: '#d4d4d4'
	},
	logWarn: {
		backgroundColor: 'rgba(255, 193, 7, 0.1)',
		color: '#ffc107'
	},
	logError: {
		backgroundColor: 'rgba(244, 67, 54, 0.1)',
		color: '#f44336'
	},
	logTime: {
		color: '#666',
		marginRight: '8px',
		fontSize: '10px'
	},
	logSource: {
		color: '#666',
		fontSize: '10px',
		display: 'block',
		marginTop: '2px'
	},
	networkEntry: {
		padding: '8px',
		borderRadius: '4px',
		marginBottom: '4px',
		backgroundColor: 'rgba(255, 255, 255, 0.05)',
		display: 'flex',
		flexDirection: 'column',
		gap: '4px'
	},
	networkEntryHeader: {
		display: 'flex',
		alignItems: 'center',
		gap: '8px',
		width: '100%'
	},
	networkMethod: {
		fontWeight: 'bold',
		fontSize: '11px',
		padding: '2px 6px',
		borderRadius: '3px',
		backgroundColor: 'rgba(255, 255, 255, 0.1)'
	},
	networkStatus: {
		fontWeight: 'bold',
		fontSize: '12px',
		marginLeft: 'auto'
	},
	networkDuration: {
		color: '#888',
		fontSize: '11px'
	},
	networkUrl: {
		color: '#d4d4d4',
		fontSize: '11px',
		wordBreak: 'break-all',
		lineHeight: 1.3
	},
	statusSuccess: {
		color: '#4caf50'
	},
	statusError: {
		color: '#f44336'
	},
	statusPending: {
		color: '#ffc107'
	},
	actionEntry: {
		padding: '6px 8px',
		borderRadius: '4px',
		marginBottom: '4px',
		backgroundColor: 'rgba(255, 255, 255, 0.05)',
		color: '#d4d4d4'
	},
	actionType: {
		fontWeight: 'bold',
		marginRight: '8px',
		textTransform: 'uppercase',
		fontSize: '10px'
	},
	actionClick: {
		color: '#64b5f6'
	},
	actionSubmit: {
		color: '#81c784'
	},
	actionNavigation: {
		color: '#ba68c8'
	},
	controlsSection: {
		padding: '12px',
		display: 'flex',
		flexDirection: 'column',
		gap: '8px'
	},
	controlButton: {
		padding: '8px 12px',
		backgroundColor: '#333',
		border: '1px solid #444',
		borderRadius: '4px',
		color: '#fff',
		cursor: 'pointer',
		textAlign: 'left',
		transition: 'background-color 0.2s'
	},
	controlButtonDanger: {
		borderColor: '#f44336'
	},
	filterBar: {
		display: 'flex',
		gap: '4px',
		padding: '8px',
		borderBottom: '1px solid #333'
	},
	filterButton: {
		padding: '4px 8px',
		backgroundColor: 'transparent',
		border: '1px solid #444',
		borderRadius: '4px',
		color: '#888',
		cursor: 'pointer',
		fontSize: '11px'
	},
	filterButtonActive: {
		backgroundColor: '#007acc',
		border: '1px solid #007acc',
		color: '#fff'
	},
	minimizedButton: {
		position: 'fixed',
		bottom: '20px',
		left: '20px',
		width: '48px',
		height: '48px',
		borderRadius: '50%',
		backgroundColor: 'transparent',
		border: 'none',
		color: '#fff',
		cursor: 'pointer',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		zIndex: 99999,
		fontSize: '50px'
	},
	badge: {
		position: 'absolute',
		top: '-4px',
		right: '-4px',
		backgroundColor: '#f44336',
		color: '#fff',
		borderRadius: '10px',
		padding: '2px 6px',
		fontSize: '10px',
		fontWeight: 'bold'
	},
	emptyState: {
		color: '#666',
		textAlign: 'center',
		padding: '20px'
	},
	apiSwitcher: {
		display: 'flex',
		flexDirection: 'column',
		gap: '8px',
		padding: '12px',
		backgroundColor: '#252525',
		borderRadius: '4px',
		marginBottom: '8px'
	},
	apiSwitcherLabel: {
		color: '#888',
		fontSize: '11px',
		textTransform: 'uppercase',
		letterSpacing: '0.5px'
	},
	apiSwitcherButtons: {
		display: 'flex',
		gap: '8px'
	},
	apiButton: {
		flex: 1,
		padding: '8px 12px',
		backgroundColor: '#333',
		border: '1px solid #444',
		borderRadius: '4px',
		color: '#888',
		cursor: 'pointer',
		fontSize: '12px',
		transition: 'all 0.2s'
	},
	apiButtonActive: {
		backgroundColor: '#007acc',
		borderColor: '#007acc',
		color: '#fff'
	},
	apiButtonStage: {
		borderColor: '#ff9800'
	},
	apiButtonStageActive: {
		backgroundColor: '#ff9800',
		borderColor: '#ff9800',
		color: '#fff'
	},
	currentApiLabel: {
		color: '#666',
		fontSize: '10px',
		marginTop: '4px',
		wordBreak: 'break-all'
	},
	copyButton: {
		background: 'none',
		border: 'none',
		color: '#666',
		cursor: 'pointer',
		padding: '2px 4px',
		borderRadius: '2px',
		fontSize: '10px',
		marginLeft: '4px',
		opacity: 0.7,
		transition: 'opacity 0.2s'
	},
	copyAllButton: {
		padding: '4px 8px',
		backgroundColor: 'transparent',
		border: '1px solid #444',
		borderRadius: '4px',
		color: '#888',
		cursor: 'pointer',
		fontSize: '11px'
	},
	logEntryWrapper: {
		display: 'flex',
		alignItems: 'flex-start',
		justifyContent: 'space-between',
		gap: '4px'
	},
	logContent: {
		flex: 1,
		minWidth: 0
	},
	networkDetails: {
		marginTop: '8px',
		padding: '8px',
		backgroundColor: 'rgba(0, 0, 0, 0.3)',
		borderRadius: '4px',
		fontSize: '11px'
	},
	networkDetailsSection: {
		marginBottom: '8px'
	},
	networkDetailsLabel: {
		color: '#888',
		fontSize: '10px',
		textTransform: 'uppercase',
		marginBottom: '4px',
		display: 'block'
	},
	networkDetailsContent: {
		color: '#d4d4d4',
		whiteSpace: 'pre-wrap',
		wordBreak: 'break-all',
		maxHeight: '150px',
		overflow: 'auto',
		backgroundColor: 'rgba(0, 0, 0, 0.2)',
		padding: '6px',
		borderRadius: '3px',
		fontFamily: 'monospace',
		fontSize: '10px'
	},
	networkEntryClickable: {
		cursor: 'pointer'
	},
	expandIcon: {
		color: '#666',
		fontSize: '10px',
		marginLeft: 'auto'
	},
	headersToggle: {
		display: 'flex',
		alignItems: 'center',
		gap: '6px',
		background: 'none',
		border: 'none',
		padding: '4px 0',
		cursor: 'pointer',
		width: '100%',
		textAlign: 'left',
		color: '#fff'
	},
	headersToggleIcon: {
		color: '#fff',
		fontSize: '10px'
	},
	headersCount: {
		color: '#666',
		fontSize: '10px'
	},
	resizeN: {
		position: 'absolute',
		top: 0,
		left: 8,
		right: 8,
		height: 6,
		cursor: 'ns-resize'
	},
	resizeS: {
		position: 'absolute',
		bottom: 0,
		left: 8,
		right: 8,
		height: 6,
		cursor: 'ns-resize'
	},
	resizeE: {
		position: 'absolute',
		top: 8,
		right: 0,
		bottom: 8,
		width: 6,
		cursor: 'ew-resize'
	},
	resizeW: {
		position: 'absolute',
		top: 8,
		left: 0,
		bottom: 8,
		width: 6,
		cursor: 'ew-resize'
	},
	resizeNE: {
		position: 'absolute',
		top: 0,
		right: 0,
		width: 12,
		height: 12,
		cursor: 'nesw-resize'
	},
	resizeNW: {
		position: 'absolute',
		top: 0,
		left: 0,
		width: 12,
		height: 12,
		cursor: 'nwse-resize'
	},
	resizeSE: {
		position: 'absolute',
		bottom: 0,
		right: 0,
		width: 12,
		height: 12,
		cursor: 'nwse-resize'
	},
	resizeSW: {
		position: 'absolute',
		bottom: 0,
		left: 0,
		width: 12,
		height: 12,
		cursor: 'nesw-resize'
	}
}
